import React from "react";
import { Redirect } from "react-router-dom";
import Login from "../modules/Login/index";
import { LoginSSO } from "../modules/Login/LoginSSO";
//check if a user is logged in
export function isLoggedIn() {
  return localStorage.getItem("token");
}
const environment = process.env.REACT_APP_ENVIRONMENT;
const AuthChecker = () => {
  // const account = useRecoilValue(accountAtom);
  // isLoggedIn = account.username.length > 0 && account.token.length > 0;
  //redirect user to dashboard if login is true else back to login
  return isLoggedIn() ? (
    <Redirect to="/home" />
  ) : environment === "development" ? (
    <Login />
  ) : (
    <LoginSSO />
  );
};

export default AuthChecker;
